import { IRegistrationSettingsQuery } from '../interfaces/registration-settings.query.interface';
import { RegistrationBlockedReason } from '../enums/registration-blocked-reason.enum';

// @dynamic
export class RegistrationSettings {
    registrationStartDate: string | null;
    registrationEndDate: string | null;
    visibility: string;
    registrationStatus: string;
    courseStatus: string;
    minAmountOfParticipants: number | null;
    maxAmountOfParticipants: number | null;
    openSpots: number | null;
    closureReason: number | null;
    registrationBlocked: boolean;
    registrationBlockedReason: RegistrationBlockedReason | null;

    constructor(query: IRegistrationSettingsQuery) {
        this.registrationStartDate = query.registration_start_date;
        this.registrationEndDate = query.registration_end_date;
        this.visibility = query.visibility;
        this.registrationStatus = query.registration_status;
        this.courseStatus = query.course_status;
        this.minAmountOfParticipants = query.min_amount_of_participants;
        this.maxAmountOfParticipants = query.max_amount_of_participants;
        this.openSpots = query.open_spots ?? null;
        this.closureReason = query.closure_reason;
        this.registrationBlocked = query.registration_blocked;
        this.registrationBlockedReason = query.registration_blocked_reason;
    }
}

